import * as types from './mutation-types'
let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_VIDEO_CATEGORY] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.category = payload
  },
  [types.SET_VIDEO_CATEGORIES] (state, payload) {
    state.categories = payload.data
    state.pagination = payload.meta.pagination
  }
}
